import { Check } from './Check';
import { WeighingType } from './weighing-type.enum';
import { TransportScope } from "src/tmc-yard/common/model/transport.model";

export class DeclineLeaveReason {
  static UMBRUECKUNG_RUNNING = 'UMBRUECKUNG_RUNNING';
  static HANDOUTED_SUPPLEMENTARY_EQUIPMENT = 'HANDOUTED_SUPPLEMENTARY_EQUIPMENT';
  static PROCESSING_STATION_ASSIGNED = 'PROCESSING_STATION_ASSIGNED';
}

export class Transport {
    id: number;
    numberPlate: string;
    name: string;
    carrier: string;
    declineLeaveCauses: string[];
    checks: Check[];
    identifier: string;
    transportScope: TransportScope;
    weighingType: WeighingType;
    weight: number;
    autoWeight: number;
    autoWeightSource: string;
    allowExitDespiteOfRuleViolation: boolean;
}
